module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-toast-container"
  }, [_c('transition', {
    attrs: {
      "name": "toast-animation"
    }
  }, [(_vm.toast) ? _c('div', {
    staticClass: "app-toast"
  }, [_vm._m(0), _vm._v(" "), _c('app-icon', {
    staticClass: "app-toast__app-icon",
    attrs: {
      "name": _vm.toast.icon,
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-toast__text"
  }, [_vm._v(_vm._s(_vm.toast.title))])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "app-toast__icon",
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 24 24",
      "enable-background": "new 0 0 24 24",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.11,12.382c0.101-0.244,0.101-0.52,0-0.764c-0.051-0.123-0.124-0.233-0.217-0.326L14.05,6.449\n                    c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L15.773,11H5.813c-0.552,0-1,0.447-1,1s0.448,1,1,1h9.96l-3.137,3.138\n                    c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293l4.843-4.844\n                    C18.985,12.615,19.059,12.504,19.11,12.382z"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351a7c34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/AppToast/index.vue
// module id = 440
// module chunks = 1